import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import store, { RootState } from '../store/index';
import { ReactNode } from 'react';

interface ThemeWrapperProps {
    children: ReactNode; // 指定children的类型为ReactNode
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Select: {
                        colorPrimary: themeColor,
                        colorText:'#33364b',
                        fontSizeIcon: 10,
                        fontSizeLG: 10,
                        fontSize: 12,
                        // optionActiveBg:themeColor,
                    },
                    Button: {
                        defaultBg: themeColor
                    },
                    Input: {
                        activeBorderColor: themeColor,
                        activeShadow: themeColor,
                        colorIconHover: themeColor, 
                        hoverBorderColor: themeColor,
                        addonBg:themeColor,
                        colorIcon: '#0e08f9',
                    }
                },
                token: {
                    colorPrimary: themeColor,
                    borderRadius: 2,
                    colorBgContainer: '#ffffff',
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default ThemeWrapper;